import { createStore } from "redux";
import rootReducters from "./reducters";

const store = createStore(rootReducters)

export default store